class FilterNode extends Weaver.Node

  @className = 'FilterNode'

  constructor: (id) ->
    super(id)

  create: (name = "New Filter", filterType = 'lowshelf', freqVal = 1000, freqGain = 0.5) ->
    type = await Weaver.Node.firstOrCreate('Filter')
    @set('name', name)
    @set('filterType', filterType)
    @set('freqVal', freqVal)
    @set('freqGain', freqGain)
    @relation('type').add(type)
    @save()

export default FilterNode
